export const bus = {
  'images': [],
  'mainFeatures': [
    'Nano Graphite Coating with Premium Nature Rubber.'
  ],
  'material': [
    'Rubber: Premium Nature Rubber.',
    'Steel: SGCC, Electrostatic Powder Coating.',
    'Rivet: SUS302',
    'Plastic: Spacer & Adapter: POM',
    'Stainless Steel Backing: SUS304ES',
  ],
  'featureIcons': ["02", "03"],
  'otherFeatures': ['01', '02'],
  'specification': [
    { "inch": "24", "mm": "600", "claw": "8", "width": "6", "thickness": "1.2" },
    { "inch": "26", "mm": "650", "claw": "8", "width": "8", "thickness": "1.2" },
    { "inch": "28", "mm": "700", "claw": "8", "width": "8", "thickness": "1.2" },
    { "inch": "30", "mm": "765", "claw": "8", "width": "9", "thickness": "1.2" },
    { "inch": "32", "mm": "800", "claw": "8", "width": "9", "thickness": "1.2" },
    { "inch": "35", "mm": "890", "claw": "8", "width": "9", "thickness": "1.2" },
    { "inch": "40", "mm": "1000", "claw": "8", "width": "9", "thickness": "1.2" }
  ],
  'adapters': ["f6", "u", "u1", "u2"]
}